<template>
  <div class="category-container">
    <pageTitle>企业信息管理</pageTitle>

    <div class="main">
      <el-button type="primary" plain @click="addCompanyDialog=true">添加企业信息</el-button>
      <el-dialog title="新增企业信息" :visible.sync="addCompanyDialog">
        <el-form :model="addCompanyData" ref="addCompanyData" :rules="addCompanyRules" label-width="200px">
          <el-form-item label="企业名称" prop="company_name">
            <el-input v-model="addCompanyData.company_name"></el-input>
          </el-form-item>
          <el-form-item label="种子生产经营许可证编号" prop="seed_license_number">
            <el-input v-model="addCompanyData.seed_license_number"></el-input>
          </el-form-item>
          <el-form-item label="企业地址" prop="company_address">
            <el-input v-model="addCompanyData.company_address"></el-input>
          </el-form-item>
          <el-form-item label="企业电话（追溯码上显示）" prop="company_phone">
            <el-input v-model="addCompanyData.company_phone"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addCompanyDialog = false">取 消</el-button>
          <el-button type="primary" @click="addCompany('addCompanyData')">确 定</el-button>
        </div>
      </el-dialog>


      <div class="categoryList">
        <el-table :data="companyListData" stripe style="width:100%;margin-bottom: 35px;">
          <el-table-column width="300px" prop="company_name" label="公司名称"></el-table-column>
          <el-table-column width="320px" prop="seed_license_number" label="种子生产经营许可证编号"></el-table-column>
          <el-table-column width="350px" prop="company_address" label="企业地址"></el-table-column>
          <el-table-column width="120px" prop="company_phone" label="公司电话"></el-table-column>
          <el-table-column width="180px" prop="create_time" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" plain
                         @click.native.prevent="editorCompanyItemDataDialog(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


      <el-dialog title="编辑企业信息" :visible.sync="editorCompanyDialog">
        <el-form :model="editorCompanyData" ref="editorCompanyData" :rules="addCompanyRules" label-width="200px">
          <el-form-item label="企业名称" prop="company_name">
            <el-input v-model="editorCompanyData.company_name"></el-input>
          </el-form-item>
          <el-form-item label="种子生产经营许可证编号" prop="seed_license_number">
            <el-input v-model="editorCompanyData.seed_license_number"></el-input>
          </el-form-item>
          <el-form-item label="企业地址" prop="company_address">
            <el-input v-model="editorCompanyData.company_address"></el-input>
          </el-form-item>
          <el-form-item label="企业电话（追溯码上显示）" prop="company_phone">
            <el-input v-model="editorCompanyData.company_phone"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editorCompanyDialog = false">取 消</el-button>
          <el-button type="primary" @click="editorCompany('editorCompanyData')">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import pageTitle from "../components/pageTitle";

export default {
  name: "company",
  components: {
    pageTitle
  },
  data() {
    return {
      //添加企业数据
      addCompanyData: {},
      //添加企业数据验证规则
      addCompanyRules: {
        company_name: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
        ],
        seed_license_number: [
          {required: true, message: "请输入种子生产经营许可证编号", trigger: "blur"}
        ],
        company_address: [
          {required: true, message: "请输入公司地址", trigger: "blur"}
        ],
        company_phone: [
          {required: true, message: "企业电话（追溯码上显示）", trigger: "blur"}
        ]
      },

      //企业列表数据
      companyListData: null,

      //添加企业数据模态框
      addCompanyDialog: false,

      //编辑企业数据
      editorCompanyData: {},
      //编辑企业数据模态框
      editorCompanyDialog: false
    }
  },
  methods: {
    //获取公司数据
    getCompanyListData() {
      this.axios.post('company/getCompanyList').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          // success.data.data.create_time = success.data.data.create_time.substring(0, success.data.data.create_time.length - 3)
          this.companyListData = success.data.data
        }
      })
    },

    //添加企业
    addCompany(companyData) {
      this.$refs[companyData].validate((valiResult) => {
        if (valiResult) {
          this.axios.post('company/addCompany', this.addCompanyData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '添加企业信息成功'
              })
              this.getCompanyListData()
              this.addCompanyDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //编辑企业
    editorCompany(companyData) {
      this.$refs[companyData].validate((valiResult) => {
        if (valiResult) {

          console.log('==========')
          console.log(this.editorCompanyData)
          console.log('==========')

          this.axios.post('company/updateCompany', this.editorCompanyData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '编辑企业信息成功'
              })
              this.getCompanyListData()
              this.addCompanyDialog = false
              this.editorCompanyDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //打开编辑模态框
    editorCompanyItemDataDialog(index, row) {
      this.editorCompanyDialog = true
      this.editorCompanyData = {
        id: row.id,
        company_name: row.company_name,
        seed_license_number: row.seed_license_number,
        company_address: row.company_address,
        company_phone: row.company_phone
      }
    }
  },
  created() {
    this.getCompanyListData()
  }
}
</script>

<style scoped lang="scss">

.category-container {

  .main {
    margin-left: 10px;

    .categoryList {
      margin-top: 30px;

      ul {
        border-radius: 5px;
        overflow: hidden;

        li {
          list-style: none;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #707070;
          background-color: #DCDFE6;

          label {
            float: left;
            margin-left: 20px;
          }

          .el-button {
            float: right;
            margin-top: 5px;
            margin-right: 10px;
          }
        }

        li:hover {
          background-color: #c0c4cc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/company.vue